export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
//it is a common practice in configuration files
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'c226b13b-2393-490b-a968-794f5b6d4d13';
export const MODAL_CLOSE_SEC = 2.5;
